import { Directive } from '@angular/core';
import { AbstractControlOptions, Validators } from '@angular/forms';
import { AuthentificationService } from '@app/authentification/authentification.service';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import * as _ from 'lodash';

@Directive()
export abstract class EaDocumentFormBuilder extends PrFormAbstract {
  isConsultant: boolean;

  constructor(
    protected formConstructor: PrFormConstructor,
    protected authenticationService: AuthentificationService,
  ) {
    super(formConstructor);
    authenticationService.isConsultant().subscribe(consultant => {
      this.isConsultant = consultant;
    });
  }

  generate(entity: any) {
    let options: AbstractControlOptions = {};
    return this.formBuilder.group(
      {
        ownerIds: [
          entity ? entity.ownerIds : null,
          [
            this.prFormService.RefreshEveryValidators(['category']),
            Validators.required,
          ],
        ],

        category: [
          entity ? entity.category : null,
          [
            this.prFormService.RefreshEveryValidators([
              'document',
              'type',
              'providerId',
              'productId',
              'isSigned',
              'label',
            ]),
            Validators.required,
          ],
        ],

        label: [
          entity ? entity.label : null,
          this.prFormService.AddValidatorsBasedOnCondition(
            this.prFormService
              .isTargetControlValueEqualTo('category', val =>
                ['OTHER'].includes(val),
              )
              .bind(this),
            Validators.required,
          ),
        ],

        document: [
          entity ? entity.document : null,
          [
            this.prFormService.RefreshEveryValidators([
              'dateExpired',
              'documentType',
            ]),
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo(
                  'category',
                  val => !['OTHER'].includes(val),
                )
                .bind(this),
              Validators.required,
            ),
          ],
        ],

        dateExpired: [
          entity ? entity.dateExpired : null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('document', val =>
                  ['TITRE_DE_SEJOUR', 'CNI', 'PASSEPORT'].includes(val),
                )
                .bind(this),
              Validators.required,
            ),
          ],
        ],
        documentType: [
          entity ? entity.documentType : null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('document', val =>
                  ['JUSTIFICATIF_DE_DOMICILE'].includes(val),
                )
                .bind(this),
              Validators.required,
            ),
          ],
        ],

        productCategory: [
          entity ? entity.productCategory : null,
          [
            this.prFormService.RefreshEveryValidators([
              'productType',
              'productId',
            ]),
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('category', val =>
                  ['CONTRACT'].includes(val),
                )
                .bind(this),
              Validators.required,
            ),
          ],
        ],

        productType: [
          entity ? entity.productType : null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              (this.prFormService.isTargetControlValueEqualTo('category', val =>
                ['CONTRACT'].includes(val),
              ),
              this.prFormService.isTargetControlValueEqualTo(
                'productCategory',
                val =>
                  [
                    'FINANCIAL_ASSET',
                    'UNFURNISHED_REALESTATE',
                    'DEFISCALISING_ASSET',
                    'FURNISHED_REALESTATE',
                  ].includes(val),
              )),
              Validators.required,
            ),
          ],
        ],

        providerId: [
          entity ? entity.providerId : null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('category', val =>
                  ['CONTRACT'].includes(val),
                )
                .bind(this),
              Validators.required,
            ),
          ],
        ],

        productId: [
          entity ? entity.productId : null,
          [
            this.prFormService.AddValidatorsBasedOnCondition(
              this.prFormService
                .isTargetControlValueEqualTo('category', val =>
                  ['CONTRACT'].includes(val),
                )
                .bind(this),
              Validators.required,
            ),
          ],
        ],

        isSigned: [
          entity && !_.isNil(entity.isSigned) ? entity.isSigned : false,
          [Validators.required],
        ],

        accountId: [entity ? entity.accountId : null],
        file: [entity ? entity.file : null],
      },
      options,
    );
  }

  extract() {
    return {
      ownerIds: this.utilsService.emptyIsNull(this.form.value.ownerIds),
      category: this.utilsService.emptyIsNull(this.form.value.category),
      label: this.utilsService.emptyIsNull(this.form.value.label),
      document: this.utilsService.emptyIsNull(this.form.value.document),
      dateExpired: this.utilsService.emptyIsNull(this.form.value.dateExpired),
      productCategory: this.utilsService.emptyIsNull(
        this.form.value.productCategory,
      ),
      accountId: this.utilsService.emptyIsNull(this.form.value.accountId),
      file: this.utilsService.emptyIsNull(this.form.value.file),
      productType: this.utilsService.emptyIsNull(this.form.value.productType),
      documentType: this.utilsService.emptyIsNull(this.form.value.documentType),
      providerId: this.utilsService.emptyIsNull(this.form.value.providerId),
      productId: this.utilsService.emptyIsNull(this.form.value.productId),
      isSigned: this.utilsService.emptyIsNull(this.form.value.isSigned),
      reviewed: !!this.isConsultant,
      visible: true,
    };
  }
}
